import React from 'react';

import { isAppWebview } from 'v2/helpers/isAppWebview';

export function useIsAppWebview(): boolean {
  return React.useMemo(() => isAppWebview(), []);
}
